export default __webpack_public_path__ + "static/Nezasa_1_1_en-009fd5d1aa293ef9e57d63dc3da48d37.jpg";